import { doGet, doPut, doPost, doDelete } from './common';


const getList = (vname, pagination = undefined, sort = undefined, keyword = undefined) => {
  let filter = '';
  if (pagination) {
    filter = `?limit=${pagination.limit}&offset=${pagination.offset}`;
  }
  if (sort) {
    if (filter !== '') filter += `&sort=${sort}`;
    else filter = `?sort=${sort}`;
  }
  if (keyword) {
    if (filter !== '') filter += `&keyword=${keyword}`;
    else filter = `?keyword=${keyword}`;
  }
  return doGet(`/api/view/${vname}${filter}`).then(res => (res.data))
    .catch(err => { })
    .finally(() => {

    });
}

const getListCount = (vname, keyword) => {
  let filter = '';
  if (keyword) {
    filter = `?keyword=${keyword}`;
  }
  return doGet(`/api/view/${vname}/count${filter}`).then(res => (res.data.count))
    .catch(err => { })
    .finally(() => {

    });
}

export {
  getList,
  getListCount
}